import { useState, useEffect, useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Row, Col } from "react-bootstrap";
import { formatCurrency } from "../../utils/formatNumber";

const PricingCharts = ({ optData, marketPlace, selectedPrices, height }) => {
  if (height === undefined) {
    height = 400;
  }
  const [demandChartOptions, setDemandChartOptions] = useState(null);
  const { allOrderHistory } = useMemo(() => {
    if (!optData) {
      return {
        allOrderHistory: null,
      };
    }
    const allOrderHistory = optData.order_history;
    return {
      allOrderHistory,
    };
  }, [optData]);

  useEffect(() => {
    if (optData.order_history) {
      setDemandChartOptions(getDemandChartOptions(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOrderHistory, selectedPrices]);

  const getDemandChartOptions = () => {
    let cats = [];
    let priceData = [];
    let bsrData = [];
    let maxPrice = 0.0;

    Object.keys(allOrderHistory).map((k) => {
      if (allOrderHistory[k].price > maxPrice) {
        maxPrice = allOrderHistory[k].price;
      }
      return null;
    });

    Object.keys(allOrderHistory).map((k) => {
      cats.push(k);
      priceData.push(allOrderHistory[k].price);

      if (allOrderHistory[k].bsr) {
        bsrData.push(allOrderHistory[k].bsr);
      } else {
        bsrData.push(0);
      }

      return null;
    });

    priceData = priceData.slice(priceData.length - 30, priceData.length);
    bsrData = bsrData.slice(bsrData.length - 30, bsrData.length);
    cats = cats.slice(cats.length - 30, cats.length);

    const options = {
      chart: {
        type: "column",
        zoomType: "x",
        height: height,
        style: {
          fontFamily: "Poppins",
          fontWeight: 300,
          fontSize: "15px",
        },
      },
      title: {
        text: null,
      },
      yAxis: [
        {
          title: {
            text: "Price",
          },
          opposite: true,
        },
        {
          title: {
            text: "BSR Rank",
          },
          visible: false,
        },
      ],
      xAxis: {
        title: {
          text: "Date",
        },
        labels: {
          enabled: false,
        },
        categories: cats,
      },
      legend: {
        enabled: true,
        verticalAlign: "bottom",
      },
      series: [
        {
          name: "Price",
          data: priceData,
          type: "line",
          color: "#d71166",
        },
        {
          name: "BSR",
          data: bsrData,
          type: "line",
          color: "#573675",
          yAxis: 1,
          visible: false,
        },
      ],
      tooltip: {
        formatter: function () {
          const idx = this.point.index;
          const html = [];
          html.push(`<div>`);
          html.push(`<div><strong>Performance on: ${this.x}</strong></div>`);
          html.push(`<div><strong>Price</strong>: ${formatCurrency(priceData[idx], marketPlace.marketPlace)}</div>`);
          html.push(`<div><strong>BSR Ranking</strong>: ${bsrData[idx] ? bsrData[idx].toFixed(0) : 0}</div>`);

          html.push(`</div>`);

          return html.join(`<br style="padding-top: 200px"/>`);
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
              maxHeight: 1300,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    };

    return options;
  };

  if (!optData.order_history) {
    return null;
  }

  const monthlyProfitOver = [];
  const monthlyProfitBest = [];
  const priceCategory = [];
  if (optData?.pricing_data) {
    optData.pricing_data
      .filter((r) => {
        return r.num_days_at_price > 0;
      })
      .map((k) => {
        if (k.best_price) {
          monthlyProfitOver.push(null);
          monthlyProfitBest.push(k.monthly_profit);
        } else {
          monthlyProfitOver.push(k.monthly_profit);
          monthlyProfitBest.push(null);
        }

        priceCategory.push(k.price);
        return null;
      });
  }

  return (
    <Row className={`pb-5`}>
      <Col xs={12} md={12} lg={12}>
        <HighchartsReact highcharts={Highcharts} options={demandChartOptions} />
      </Col>
    </Row>
  );
};

export default PricingCharts;
